import React from 'react';
// --- external imports ------

import styled from '~/utils/styled';
import Asset from '~/containers/GameAsset/BaseAssets';
// --- internal imports ------

import AuthBackdrop from '~/authentication/AuthBackdrop';
import { ModalBackground } from '~/authentication/AuthAssets';
// --- local imports ------

// region [Projection Constants]
const HEADER_PROJECTION = { width: 632 };
const MESSAGE_PROJECTION = { width: 632 };
// endregion

const HeaderText = styled(Asset.Text.withProps({ fontSize: 128, projection: HEADER_PROJECTION }))`
	font-family: "LuckiestGuy";
	font-weight: 400;
	color: #fff5b0;
	text-shadow: -4px 2px 0 rgba(77, 47, 28, 1);
`;

const MessageText = styled(Asset.Text.withProps({ fontSize: 32, projection: MESSAGE_PROJECTION }))`
	font-family: "NotoSans";
	font-weight: 800;
	color: #fff5b0;
`;

function StatusScreen({ header, message }) {
	return (
		<AuthBackdrop>
			<ModalBackground
				x={528}
				y={148}
				shouldFadeIn={false}
			/>
			<HeaderText
				x={644}
				y={212}
				shouldFadeIn={false}
			>
				{header}
			</HeaderText>
			<MessageText
				x={644}
				y={468}
				shouldFadeIn={false}
			>
				{message}
			</MessageText>
		</AuthBackdrop>
	);
}

export default StatusScreen;
